import { Box, Button, Spinner, Text, useToast } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import style from './style.module.css';
import axios from 'axios';

function LeaderBoard() {
  const [sortedLeaderBoard, setSortedLeaderBoard] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const toast = useToast();

  useEffect(() => {
    fetchLeaderBoard();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchLeaderBoard = ()=>{
    setLoading(true);
    setError(false);

    axios
    .get('/leaderboard')
    .then(response => {
      if(response.data.message === 'success'){
        setSortedLeaderBoard(
          response.data.data &&
            response.data.data
              .sort((a, b) => parseFloat(b.invites) - parseFloat(a.invites))
              .map((data, index) => index <= 9 && data));
      }
      setLoading(false);
    })

    .catch(error => {
    console.log("🚀 ~ file: index.js ~ line 27 ~ useEffect ~ error", {error})
    setLoading(false);
    setError(true);
      if (error && error.message && error.message.indexOf('Network Error') !== -1) {
        return toast({
          title: 'Network Error',
          position: 'top-right',
          description: 'Looks Like you are not connected to the internet',
          status: 'warning',
          duration: 9000,
          isClosable: true,
        });
      }else  {
        return toast({
          title: 'Opps!',
          position: 'top-right',
          description: 'Something went wrong',
          status: 'error',
          duration: 9000,
          isClosable: true,
        });
      }
    });
  }


  return (
    <Box marginBottom="50px">
      <Box className={style.leaderboard_content}>
        <h1 className={style.leaderboard_title}
          style={{
            textAlign: 'center',
            marginBottom: '10px',
            fontSize: '25px',
            fontWeight: 'bolder',
          }}
          >LeaderBoard 😃</h1>
        <p>
          Your details will appear here if you are among our top referrals, we
          will be giving out amazing prizes to our top 10 referrals. Check below{' '}
        </p>

        <Box marginTop="10px" marginBottom="50px">
          {loading ? (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Spinner size="xl" color="red.500" />
            </div>
          ) : 
          error 
             ? <Box textAlign="center" mt="35px">
                <Text color="red">Oops, leaderboard cannot load at this time</Text>
                <Button color="white"
                        marginTop="6px"
                        borderRadius="20px"
                        backgroundColor="#562fb6" onClick={fetchLeaderBoard}>Reload</Button>
            </Box> : (
            <Table size="sm" variant="simple">
              <Thead>
                <Tr>
                  <Th fontWeight="bold">Rank</Th>
                  <Th fontWeight="bold">User</Th>
                  <Th fontWeight="bold" isNumeric>
                    Referrals
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {sortedLeaderBoard && sortedLeaderBoard.length > 0 ? (
                  sortedLeaderBoard.map((data, index) => {
                    return (
                      data && (
                        <Tr key={index} className={index === 0 ? style.champion : ''}>
                          <Td>
                            {index === 0 ? (
                              <span>1 👑</span>
                            ) : (
                              <span>{index + 1}</span>
                            )}
                          </Td>
                          <Td>{data.name}</Td>
                          <Td isNumeric>{data.invites}</Td>
                        </Tr>
                      )
                    );
                  })
                ) : (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <h3 style={{ marginTop: '5px' }}>
                      Be the first to start the Leaderboard
                    </h3>
                  </div>
                )}
              </Tbody>
            </Table>
          )}
        </Box>

        <Box marginTop="20px" py="6">
          <h3>Prizes</h3>
          <ul className={style.prizes_list}>
            <li>Tshirts</li>
            <li>Stickers</li>
            <li>Handwritten message from the founders</li>
            <li>Opportunity to feature in our commercial(Ad)</li>
            <li>Special shout-out on social media</li>
          </ul>
        </Box>
      </Box>
    </Box>
  );
}

export default LeaderBoard;